import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { Controls } from "@common/treeToggle";
import { DetailsViews, Views } from "../api/views";
import { Context } from "../context";
import { Props } from "./types";
import { ToggleArrow } from "./toggleArrow";
import { DetailsViewSelector } from "./detailsViewSelector";
import styles from "./styles.scss";

function WbsHeader({ isOpen, toggle }: Props) {
  const { t } = useTranslation();
  const { detailsView, cell, currentView } = React.useContext(Context);

  return (
    <div
      className={classNames(styles.wbsHeader, {
        [styles.open]: isOpen,
      })}
      style={{
        minHeight:
          cell.height +
          1 +
          (currentView === Views.DAILY
            ? cell.height * 2
            : cell.height + cell.height * (1 / 3)),
      }}
    >
      <div className={styles.header}>
        <div className={styles.row}>
          <Controls />
          {isOpen && <DetailsViewSelector />}
        </div>
        <div className={styles.row}>
          <p className={styles.label}>{t("gantt.details.name")}</p>
          <div className={styles.action} onClick={toggle}>
            <p className={styles.text}>{t("gantt.details.title")}</p>
            <ToggleArrow className={styles.icon} />
          </div>
          {isOpen && (
            <div className={styles.detailsViewToggle}>
              {detailsView === DetailsViews.DATES ? (
                <div className={styles.details}>
                  <div>
                    <div className={styles.detail}>
                      <p>{t("gantt.details.startDate")}</p>
                    </div>
                  </div>
                  <div>
                    <div className={styles.detail}>
                      <p>{t("gantt.details.endDate")}</p>
                    </div>
                  </div>
                  <div>
                    <div className={styles.detail}>
                      <p>{t("gantt.details.duration")}</p>
                    </div>
                  </div>
                </div>
              ) : (
                <div className={styles.details}>
                  <div>
                    <div className={styles.detail}>
                      <p>{t("gantt.details.estimated")}</p>
                    </div>
                  </div>
                  <div>
                    <div className={styles.detail}>
                      <p>{t("gantt.details.allocated")}</p>
                    </div>
                  </div>
                  <div>
                    <div className={styles.detail}>
                      <p>{t("gantt.details.progress")}</p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export { WbsHeader };
